import { apiClient } from '@utils';

interface FetchProps {
  fullName: string;
}

export const useExternalRestrictedUsers = (values?: FetchProps) => {
  const result = apiClient.customer.retrieveExternalRestrictedUsers.useQuery(['external-users', values?.fullName], {
    query: { fullName: values?.fullName || '' },
  });
  return { ...result, data: result.data?.body?.users };
};
